import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IDeclarationFormReq, IDeclarationFormRes } from '@core/main/types';
const hostUrl = getHostbaseUrl();

/**
 * 报表中心 - 代办申报表分页
 */
export async function queryDeclarationFormPage(param: IDeclarationFormReq) {
  let data = [] as IDeclarationFormRes[];
  let total = 0;

  try {
    const { code, context, message } = await Http.post<{ data: IDeclarationFormRes[]; total: number }>(`${hostUrl}/report/settlement/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IDeclarationFormRes[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 报表中心 - 代办申报表导出
 */
export async function exportDeclarationForm(param: IDeclarationFormReq) {
  let url = '';

  try {
    const { code, context, message } = await Http.post<string>(`${hostUrl}/report/settlement/export`, param);

    if (code === EAxiosResponseCode.Succeed) {
      url = context || '';
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return url;
}

/**
 * 报表中心 - 代办申报表 - 打包导出所有
 */
export async function exportAllDeclarationForm(id: number) {
  let url = '';

  try {
    const { code, context, message } = await Http.post<string>(`${hostUrl}/report/settlement/batch-download/${id}`);

    if (code === EAxiosResponseCode.Succeed) {
      url = context || '';
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return url;
}